import TopBar from "../components/TopBar";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import HeroSection from "../components/HeroSection";
import ProductGrid from "../components/ProductGrid";
import Footer from "../components/Footer";
import ProductGridKids from "../components/ProductGridKids ";
import ProductGridShop from "../components/ProductGridShop";
import WhatsAppButton from "../components/WhatsAppButton";

export default function Home() {
  return (
    <>
      <TopBar />
      <Navbar />
 
      <div className="max-w-7xl mx-auto p-5">

        <HeroSection />

        <div className="grid lg:grid-cols-1 gap-6 mt-8">

          <Sidebar />

          <div className="lg:col-span-3">

            <h2 className="text-3xl font-bold mb-6">
              Ladies Fashion Collection
            </h2>

            <ProductGrid />

          </div>
          <div className="lg:col-span-3">

            <h2 className="text-3xl font-bold mb-6">
              Kids Collection
            </h2>

            <ProductGridKids />

          </div>



          <div className="lg:col-span-3">

            <h2 className="text-3xl font-bold mb-6">
              Modern Collection
            </h2>

            <ProductGridShop />

          </div>


<div className="max-w-7xl mx-auto px-4 py-10">
      {/* page content */}

      <Footer />
       <WhatsAppButton />
    </div>

        </div>
      </div> 
    </>
  );
}